import React from 'react'
import Placeholder from 'shared-components/Placeholder'

const posts = [1, 2, 3]
const styles = {
  img: { backgroundColor: 'var(--placeholder-bg)', border: 0 },
}

export function BlogPostsPlaceholder() {
  return (
    <>
      {posts.map((post) => {
        return (
          <div className="blog-posts__a" key={post}>
            <div className="blog-posts__img panel--simple" style={styles.img} />

            <div>
              <p className="margin-top-1 txt-size-12 txt-default">
                <Placeholder small className="margin-top-1" />
              </p>

              <p className="margin-0 txt-subtitle">
                <Placeholder small className="margin-top-1" />
              </p>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default React.memo(BlogPostsPlaceholder)
